module.exports = __webpack_public_path__ + "static/media/Battery-100.ca6fd60e.svg";